/* eslint-disable */
import 'regenerator-runtime/runtime';
require('select2');
import {initMap } from "./map";
import { filterActions, homeVisit, settings, disableFunctions } from "./filters";
import { cookiebotFunctions } from "../cookiebot";

/* --------------------- When page is ready --------------------- */
window.initMap = initMap;

window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    location.reload();
  }
});

window.addEventListener('load', function () {
  const dealerPage = jQuery('.js-dealers').length > 0;
  if (dealerPage) {
    // For cookieconsent
    const cookieInfo = cookiebotFunctions.info();
    const cookieConsent = cookieInfo ? cookieInfo.consent.marketing : false;
    const workingEnvironment = document.querySelector('[data-env]').getAttribute('data-env');

    if (cookieConsent || workingEnvironment === 'local' || workingEnvironment === 'staging') {
      if(workingEnvironment === 'local' || workingEnvironment === 'staging') {
        initMap();
      }

      settings.resultAnchorOffsetTop = jQuery(".js-results-anchor").offset().top - jQuery('.c-header-mobile').outerHeight();

      // Create dropdown but hide it for now
      jQuery('.js-select-floors').select2({
        templateResult: (state) => {
          const placeholder = jQuery('.js-select-floors').data('search-placeholder');
          // Set placeholder
          jQuery(':input.select2-search__field').attr('placeholder', placeholder);

          let $opt = jQuery(state.element);

          if ($opt.attr('hidden')) {
            return null;
          }
          if (!state.id) {
            return state.text;
          }

          var image = state.element.dataset.image;
          var $state = jQuery(
            '<span><img class="rounded" width="30px" height="30px" src="' + image + '"/><span style="font-size:0.85rem;margin-left:5px">' + state.text + '</span></span>'
          );

          return $state;
        }
      });

      jQuery('.js-select-floors-wrapper').addClass('hide');

      // Click event for "my location"
      jQuery('.js-location').on('click', () => {
        disableFunctions();
        // send user location
        if (typeof gtag === 'function') {
          gtag('event', 'dealer', {
              'click': 'myLocation'
          });
        }
        filterActions.myLocation();
      });

      // Click event for submit button -> search input
      jQuery('.js-search-form').on('submit', (e) => {
        e.preventDefault();
        disableFunctions();

        const activeFilter = document.querySelector('.js-filter:checked');

        if(activeFilter && activeFilter.value === 'homeVisit') {
          homeVisit.init();
          return;
        }
        
        filterActions.init();
     });

    // Click event for filters
    jQuery('.js-filter').on('change', () => {
      disableFunctions();
      const activeFilter = document.querySelector('.js-filter:checked');

      if(activeFilter && activeFilter.value === 'homeVisit') {
        homeVisit.init();
        return;
      }
     
      filterActions.init();
    });

      // Click event for floor dropdown (only visible if floor filter is active)
      jQuery('.js-select-floors').on('change', () => {
        disableFunctions();
        filterActions.init();
      });
    } else {
      window.addEventListener('CookiebotOnAccept', () => {
        const newInfo = cookiebotFunctions.info();
        if(newInfo.consent.marketing) {
          location.reload();
        }
      });
    }
  }
});


// WEBPACK FOOTER //
// ./src/scripts/modules/dealers/init.js